"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScreenLoader_1 = require("./ScreenLoader");
exports.default = ScreenLoader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ScreenLoader/index.js
// module id = 1239
// module chunks = 8